import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewPropertyList = (propertyData) => {
  return async (dispatch) => {
    // if (showLoader) {
    //   dispatch({ type: "START_LOADING" });
    // }
    try {
      dispatch({ type: "GET_PROPERTY_RENTAL_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/rental-property/list`,
        propertyData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_PROPERTY_RENTAL_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PROPERTY_RENTAL_LIST_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "GET_PROPERTY_RENTAL_LIST_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
    } finally {
      // if (showLoader) {
      //   dispatch({ type: "STOP_LOADING" });
      // }
    }
  };
};

export const listPropertyRental = (propertyData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_PROPERTY_RENTAL_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project-resale/property-list`,
        propertyData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "LIST_PROPERTY_RENTAL_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "LIST_PROPERTY_RENTAL_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "LIST_PROPERTY_RENTAL_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewPropertyRental = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VIEW_PROPERTY_RENTAL_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/rental-property/view-property/${id}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "VIEW_PROPERTY_RENTAL_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "VIEW_PROPERTY_RENTAL_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_PROPERTY_RENTAL_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const statusPropertyRental = (statusData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "STATUS_PROPERTY_RENTAL_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/rental-property/property-status`,
        statusData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "STATUS_PROPERTY_RENTAL_SUCCESS",
          payload: data,
        });
        toast.success(data?.message || "Status updated successfully");
        return data;
      } else {
        dispatch({
          type: "STATUS_PROPERTY_RENTAL_FAILED",
          payload: data,
        });
        toast.error(data?.message || "Something went wrong");
      }
    } catch (error) {
      dispatch({
        type: "STATUS_PROPERTY_RENTAL_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addAdminMargin = (marginData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_RENTAL_ADMIN_MARGIN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/rental-property/add-admin-margin`,
        marginData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_RENTAL_ADMIN_MARGIN_SUCCESS", payload: data });
        toast.success("Admin Margin Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_RENTAL_ADMIN_MARGIN_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_RENTAL_ADMIN_MARGIN_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Add failed!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// Update Admin Margin  
export const updateAdminMargin = (marginData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_RENTAL_ADMIN_MARGIN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/rental-property/update-admin-margin`,
        marginData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_RENTAL_ADMIN_MARGIN_SUCCESS", payload: data });
        toast.success("Admin Margin Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_RENTAL_ADMIN_MARGIN_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_RENTAL_ADMIN_MARGIN_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Update failed!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getMarginHistory = (property_id) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_RENTAL_MARGIN_HISTORY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/rental-property/margin-history/${property_id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_RENTAL_MARGIN_HISTORY_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_RENTAL_MARGIN_HISTORY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_RENTAL_MARGIN_HISTORY_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch margin history!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const listRentalInterestedProject = (projectData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_RENTAL_INTERESTED_PROPERTY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/interested-property/list`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "LIST_RENTAL_INTERESTED_PROPERTY_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "LIST_RENTAL_INTERESTED_PROPERTY_FAILED", payload: data });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "LIST_RENTAL_INTERESTED_PROPERTY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateStatusRentalInterestedProject = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_STATUS_RENTAL_INTERESTED_PROPERTY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/interested-property/status/update`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "UPDATE_STATUS_RENTAL_INTERESTED_PROPERTY_SUCCESS",
          payload: data,
        });
        // toast.success(data?.message);
        return data;
      } else {
        dispatch({
          type: "UPDATE_STATUS_RENTAL_INTERESTED_PROPERTY_FAILED",
          payload: data,
        });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_STATUS_RENTAL_INTERESTED_PROPERTY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const assignProject = (assignData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ASSIGN_RENTAL_PROJECT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/rental-property/assign-project`,
        assignData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ASSIGN_RENTAL_PROJECT_SUCCESS", payload: data });
        // toast.success(data?.message || "Project Assigned Successfully!!");
        return data;
      } else {
        dispatch({ type: "ASSIGN_RENTAL_PROJECT_FAILED", payload: data });
        toast.error(data?.message || "Something went wrong");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ASSIGN_RENTAL_PROJECT_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Assign failed!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const addVR = (addVrData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_RENTAL_VR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/rental-property/update-vr`,
        addVrData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_RENTAL_VR_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_RENTAL_VR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_RENTAL_VR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const removeVr = (removeVrData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REMOVE_RENTAL_VR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/rental-property/remove-vr`,
        removeVrData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_RENTAL_VR_SUCCESS", payload: data });
        toast.success("VR removed successfully!");
        return data;
      } else {
        dispatch({ type: "REMOVE_RENTAL_VR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "REMOVE_RENTAL_VR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const addReel = (addLandmarkData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_RENTAL_REEL_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/file/compress-upload`,
        addLandmarkData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_RENTAL_REEL_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_RENTAL_REEL_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_RENTAL_REEL_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addAR = (arData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_RENTAL_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/rental-property/addAR`,
        arData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_RENTAL_AR_SUCCESS", payload: data });
        toast.success("AR added successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_RENTAL_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_RENTAL_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listAR = (arListData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_RENTAL_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/rental-property/listAR`,
        arListData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_RENTAL_AR_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_RENTAL_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_RENTAL_AR_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewAR = (projectId) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_RENTAL_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/rental-property/viewAR/${projectId}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_RENTAL_AR_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_RENTAL_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_RENTAL_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Error loading AR data");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateAR = (arUpdateData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_RENTAL_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `${BASE_URL}/rental-property/updateAR/${arUpdateData.id}`,
        arUpdateData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_RENTAL_AR_SUCCESS", payload: data });
        toast.success("AR updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_RENTAL_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_RENTAL_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const deleteAR = (deleteData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "DELETE_RENTAL_AR_REQUEST" });

      const { data } = await axios.delete(
        `${BASE_URL}/rental-property/deleteAR/${deleteData.id}/${deleteData.ar_id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "DELETE_RENTAL_AR_SUCCESS", payload: data });
        // toast.success("AR deleted successfully!");
        return data;
      } else {
        dispatch({ type: "DELETE_RENTAL_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "DELETE_RENTAL_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addThreeSixtyPrevVideo = (videoData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_RENTAL_THREE_SIXTY_PREV_VIDEO_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/rental-property/prev-video`,
        videoData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_RENTAL_THREE_SIXTY_PREV_VIDEO_SUCCESS", payload: data });
        toast.success("360° Preview Video added successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_RENTAL_THREE_SIXTY_PREV_VIDEO_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_RENTAL_THREE_SIXTY_PREV_VIDEO_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateThreeSixtyPrevVideo = (videoData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_RENTAL_THREE_SIXTY_PREV_VIDEO_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `${BASE_URL}/rental-property/prev-video/${videoData.project_id}`,
        { three_sixty_prev_video: videoData.three_sixty_prev_video },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_RENTAL_THREE_SIXTY_PREV_VIDEO_SUCCESS", payload: data });
        toast.success("360° Preview Video updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_RENTAL_THREE_SIXTY_PREV_VIDEO_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_RENTAL_THREE_SIXTY_PREV_VIDEO_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const addReels = (addReelsData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_RENTAL_REELS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/reels/add`,
        addReelsData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_RENTAL_REELS_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_RENTAL_REELS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_RENTAL_REELS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// updateReels.js
export const updateReels = (updateReelsData) => {
  return async (dispatch) => {
    dispatch({ type: "UPDATE_RENTAL_REELS_REQUEST" });
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/reels/update`,
        updateReelsData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_RENTAL_REELS_SUCCESS", payload: data });
        toast.success("Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_RENTAL_REELS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_RENTAL_REELS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// listReels.js
export const listReels = (listReelsData) => {
  return async (dispatch) => {
    dispatch({ type: "LIST_RENTAL_REELS_REQUEST" });
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/reels/list`,
        listReelsData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_RENTAL_REELS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "LIST_RENTAL_REELS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_RENTAL_REELS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// viewReels.js
export const viewReels = (reelId) => {
  return async (dispatch) => {
    dispatch({ type: "VIEW_RENTAL_REELS_REQUEST" });
    try {
      const { data } = await axios.get(
        `${BASE_URL}/reels/view/${reelId}`
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_RENTAL_REELS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_RENTAL_REELS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_RENTAL_REELS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const updateOwnerVerified = (ownerVerifiedData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_RENTAL_OWNER_VERIFIED_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/rental-property/update-owner-verified`,
        ownerVerifiedData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_RENTAL_OWNER_VERIFIED_SUCCESS", payload: data });
        toast.success(data?.message || "Owner verification updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_RENTAL_OWNER_VERIFIED_FAILED", payload: data });
        toast.error(data?.message || "Something went wrong");
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_RENTAL_OWNER_VERIFIED_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Update failed!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updatePropertyMedia = (mediaData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_RENTAL_PROPERTY_MEDIA_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/rental-property/update-media`,
        mediaData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_RENTAL_PROPERTY_MEDIA_SUCCESS", payload: data });
        toast.success(data?.message || "Media updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_RENTAL_PROPERTY_MEDIA_FAILED", payload: data });
        toast.error(data?.message || "Something went wrong");
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_RENTAL_PROPERTY_MEDIA_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Update failed!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateFloorPlanImage = (floorPlanData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_RENTAL_FLOOR_PLAN_IMAGE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/rental-property/update-floor-plan-image`,
        floorPlanData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_RENTAL_FLOOR_PLAN_IMAGE_SUCCESS", payload: data });
        toast.success(data?.message || "Floor plan image updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_RENTAL_FLOOR_PLAN_IMAGE_FAILED", payload: data });
        toast.error(data?.message || "Something went wrong");
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_RENTAL_FLOOR_PLAN_IMAGE_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Update failed!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateRentalLocality = (id, payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_RENTAL_LOCALITY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `${BASE_URL}/rental-property/update-locality/${id}`,
        payload,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "UPDATE_RENTAL_LOCALITY_SUCCESS",
          payload: data.data,
        });
        toast.success(data.message || "Locality updated successfully");
        return data;
      } else {
        dispatch({
          type: "UPDATE_RENTAL_LOCALITY_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_RENTAL_LOCALITY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to update locality");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getNearbyLocalities = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "NEARBY_LOCALITIES_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/rental-property/${id}/nearby-localities`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "NEARBY_LOCALITIES_SUCCESS",
          payload: data.data,
        });
        return data;
      } else {
        dispatch({
          type: "NEARBY_LOCALITIES_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "NEARBY_LOCALITIES_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};